import React from 'react';

export function LoadingSpinner({ fullScreen = true, text = "Loading..." }) {
  const containerClass = fullScreen 
    ? "fixed inset-0 flex flex-col items-center justify-center z-50" 
    : "flex flex-col items-center justify-center p-8";

  return (
    <div className={containerClass} style={{ minHeight: fullScreen ? '100vh' : '200px', background: fullScreen ? 'var(--bg-primary)' : 'transparent' }}>
      <div className="spinner mb-4" style={{ width: '40px', height: '40px', borderWidth: '4px' }}></div>
      <div className="text-muted text-sm font-semibold tracking-wider animate-pulse">{text}</div>
    </div>
  );
}
